import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAcombaBridgeStore } from '../../stores/acombaBridgeStore';
import { TranslationKey } from '../../i18n/translationKeys';
import { Button } from '../../ui/Button/Button';
import { BridgeCauseBanner } from './BridgeCauseBanner';
import { resolveBridgeCause } from '../../utils/bridge/bridgeCause';
import { getBridgeLaunchStatus } from '../../services/bridgeLaunchStatus';

export const BridgeWizard: React.FC = () => {
    const { t } = useTranslation();
    const bridgeStatus = useAcombaBridgeStore((s) => s.bridgeStatus);
    const bridgeInfo = useAcombaBridgeStore((s) => s.bridgeInfo);
    const isCheckingHealth = useAcombaBridgeStore((s) => s.isCheckingHealth);
    const checkBridgeHealth = useAcombaBridgeStore((s) => s.checkBridgeHealth);
    const [hasChecked, setHasChecked] = useState(false);

    // What Acomba saw is only consulted when the bridge itself cannot be reached — a live /health is
    // always the better answer.
    const cause = resolveBridgeCause(bridgeStatus === 'reachable', bridgeInfo, getBridgeLaunchStatus());

    const handleCheck = () => {
        setHasChecked(true);
        void checkBridgeHealth();
    };

    return (
        <div className="flex flex-col gap-l">
            <p className="text-s text-primary-700">{t(TranslationKey.AcombaBridge.Wizard.Step1)}</p>
            <Button
                type="button"
                data-testid="acomba-bridge-wizard-check-btn"
                onClick={handleCheck}
                loading={isCheckingHealth}
                className="self-start"
            >
                {isCheckingHealth
                    ? t(TranslationKey.AcombaBridge.Wizard.Checking)
                    : t(TranslationKey.AcombaBridge.Wizard.CheckBtn)}
            </Button>
            {hasChecked && cause !== 'connected' && (
                <BridgeCauseBanner cause={cause} onRetry={handleCheck} retrying={isCheckingHealth} />
            )}
        </div>
    );
};
